import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  IconButton,
  Text,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';


const headerBgImage = require('../../assets/img/longarrow.jpg'); 

const ReusableDrawer = ({
  isOpen,
  onClose,
  headerContent,
  bodyContent, 
  footerContent, 
  size = "md",
}) => {
  return (
    <Drawer 
      isOpen={isOpen} 
      onClose={onClose}  
      borderRadius="lg"  
      placement="right"
      size={size}   
      backdropFilter="auto"
      backdropInvert="80%"
      backdropBlur="2px"
    >
      <DrawerOverlay
        style={{
          background: "rgba(255, 255, 255, 0.2)",
          backdropFilter: "blur(10px)",
        }}
      />
      <DrawerContent  
        borderTopLeftRadius={{ base: 0, sm: 0, md: "12px" }}
        borderBottomLeftRadius={{ base: 0, sm: 0, md: "12px" }}
        overflow="hidden"
      >
        <DrawerHeader 
          position="relative" 
          backgroundImage={`url(${headerBgImage})`} // Use the image as a URL
          backgroundSize="cover"
          backgroundPosition="center"
          color="white"
        >
          <IconButton
            aria-label="Close"
            icon={<CloseIcon />}
            onClick={onClose}
            position="absolute"
            top={2}
            right={2}
            bg="transparent"
            color="white"
            _hover={{
              bg: "white",
              color: "#071D54",
              borderRadius: "full",
            }} 
            _focus={{ boxShadow: "none" }}
            borderRadius="none"
            size="sm"
          />
          <Text textAlign="start" fontSize="18px" color="#ffffff" fontWeight={"400"}>
            {headerContent}
          </Text>
        </DrawerHeader>

        <DrawerBody>
          {bodyContent}
        </DrawerBody>

        {footerContent && (
          <DrawerFooter>
            {footerContent}
          </DrawerFooter>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default ReusableDrawer;
